import React, {createContext, useContext, useState} from "react";

const AuthContext = createContext();

export function AuthProvider({children}) {
    const [user, setUser] = useState(null);
    const [institution, setInstitution] = useState(null);
    const [branch, setBranch] = useState(null);
    const [token, setToken] = useState(null);
    const [instLogo, setInstLogo] = useState(null);

    const setUserData = (userData) => {
        localStorage.setItem('user', JSON.stringify(userData))
        setUser(userData)
    }
    const setUserToken = (token) => {
        setToken(token)
        localStorage.setItem('token', token)
    }
    const setInstLogoData = (logo) => {
        setInstLogo(logo)
    }

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("institution");
        setUser(null);
    }
    const setInstitutionData = (institution) => {
        setInstitution(institution)
        localStorage.setItem('institution', JSON.stringify(institution))
    }
    const setBranchData = (branch) => {
        setBranch(branch)
    }

    return (
        <AuthContext.Provider value={{
            user,
            token,
            setUserData,
            setUserToken,
            logout,
            setInstLogoData,
            instLogo,
            setInstitutionData,
            institution,
            setBranchData,
            branch
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
